import { connect } from 'react-redux'
import { getApper, saveWaiChu } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getApper,
    saveWaiChu
}
const mapStateToProps = (state) => {
  return {
    ...state.WaiChuEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
